<template>
    <div>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
            <div class="search-group flex">
                <span class="name" style="position: relative;top: 5px;margin-right: 10px">上线日期：</span>
                <a-range-picker  style="width: 200px;margin-right:10px"
                                 format="YYYY-MM-DD"  :ranges="{ '近一周': [moment(getBeforeDate(7), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一个月': [moment(getBeforeDate(30), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近三个月': [moment(getBeforeDate(90), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近半年': [moment(getBeforeDate(180), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一年': [moment(getBeforeDate(365), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')] }"
                                 v-model="search.online_date"
                />
                <span class="name" style="position: relative;top: 5px;margin-right: 10px">询盘日期：</span>
                <a-range-picker  style="width: 200px;margin-right:10px"
                                 format="YYYY-MM-DD"  :ranges="{ '近一周': [moment(getBeforeDate(7), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一个月': [moment(getBeforeDate(30), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近三个月': [moment(getBeforeDate(90), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近半年': [moment(getBeforeDate(180), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一年': [moment(getBeforeDate(365), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')] }"
                                 v-model="search.inquiry_date"
                />
                <a-input  v-model="search.name" class="search-input"  placeholder="请输入客户名称搜索" allowClear />
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
                <a-button type=" " class="top_btn" @click="empty">重置</a-button>
            </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">查看 </a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import moment from "moment";
    const columns = [

        {
            title: "客户名称",
            key: "company",
            ellipsis: true,
            dataIndex: "company",
        },
         {
            title: "上线日期",
            key: "online_time",
            ellipsis: true,
            dataIndex: "online_time",
        },
        {
            title: "询盘数量",
            key: "inquiry_num_count",
            ellipsis: true,
            dataIndex: "inquiry_num_count",
        },
        {
            title: "询盘前5国家",
            key: "top_five_country",
            ellipsis: true,
            dataIndex: "top_five_country",
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                name:"",
                search: {
                    name: "",
                    online_date:[],
                    inquiry_date:[],
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Industrys"; //设置左侧导航2-2 active
        },
        computed: {

            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            moment,
            getBeforeDate(n){
                var n = n;
                var d = new Date();
                var year = d.getFullYear();
                var mon=d.getMonth()+1;
                var day=d.getDate();
                if(day <= n){
                    if(mon>1) {
                        mon=mon-1;
                    }
                    else {
                        year = year-1;
                        mon = 12;
                    }
                }
                d.setDate(d.getDate()-n);
                year = d.getFullYear();
                mon=d.getMonth()+1;
                day=d.getDate();
                let s = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day);
                return s;
            },
            getNowTime(){
                let now = new Date()
                let year = now.getFullYear() //得到年份
                let month= now.getMonth() //得到月份
                let date= now.getDate() //得到日期
                let hour = ' 00:00:00' //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1
                month = month.toString().padStart(2, '0')
                date = date.toString().padStart(2, '0')
                var defaultDate = `${year}-${month}-${date}`
                console.log(defaultDate)
                return defaultDate
            },
            empty(){
                this.search.name=""
                this.search.online_date=""
                this.search.inquiry_date=""
                this.getList()
            },

            handleChange(pagination, filters, sorter) {
                // this.filteredInfo = filters;
                // this.sortedInfo = sorter;
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatisticsDetails?id=${row.id}`)
            },
            exportList(){

              let seachData = JSON.parse(JSON.stringify(this.search))
              if (seachData.inquiry_date.length > 0) {
                seachData.inquiry_date[0] = moment(seachData.inquiry_date[0]).format('YYYY-MM-DD')
                seachData.inquiry_date[1] = moment(seachData.inquiry_date[1]).format('YYYY-MM-DD')
              }
              if(seachData.online_date.length>0){
                seachData.online_date[0] = moment(seachData.online_date[0]).format('YYYY-MM-DD')
                seachData.online_date[1] = moment(seachData.online_date[1]).format('YYYY-MM-DD')
              }
                API.service.EXPORT({...seachData ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                if (seachData.inquiry_date.length > 0) {
                    seachData.inquiry_date[0] = moment(seachData.inquiry_date[0]).format('YYYY-MM-DD')
                    seachData.inquiry_date[1] = moment(seachData.inquiry_date[1]).format('YYYY-MM-DD')
                }
                if(seachData.online_date.length>0){
                    seachData.online_date[0] = moment(seachData.online_date[0]).format('YYYY-MM-DD')
                    seachData.online_date[1] = moment(seachData.online_date[1]).format('YYYY-MM-DD')
                }
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .search-input {
        width: 200px;
        height: 32px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
</style>
